import { PRIVILEGES, type PrivilegeId } from '@stayon/auth-core';

export interface PrivilegeSurface {
  privilege: PrivilegeId;
  route: string;
  label: string;
}

/**
 * Der gemeinsame Vertrag für jede vollständig auf Privileges migrierte Oberfläche. Route,
 * Navigation, Suche und Landing beziehen sich auf dasselbe Objekt statt auf Rollenlisten.
 */
export const PRIVILEGE_SURFACES = {
  dashboard: {
    privilege: PRIVILEGES.dashboardView,
    route: '/',
    label: 'Dashboard',
  },
  cleaningQueue: {
    privilege: PRIVILEGES.cleaningQueueView,
    route: '/cleaning',
    label: 'Reinigung',
  },
  availabilityDistribution: {
    privilege: PRIVILEGES.availabilityDistributionView,
    route: '/availability-distribution',
    label: 'Verfügbarkeit & Vertrieb',
  },
} as const satisfies Record<string, PrivilegeSurface>;

export const DASHBOARD_SURFACE = PRIVILEGE_SURFACES.dashboard;
export const CLEANING_QUEUE_SURFACE = PRIVILEGE_SURFACES.cleaningQueue;
export const AVAILABILITY_DISTRIBUTION_SURFACE = PRIVILEGE_SURFACES.availabilityDistribution;
